import { ROUTE_MENU, ROUTE_ORDER } from "../constants";

/** Footer Braze banner on menu category and order item detail pages (desktop). */
export function isFooterBrazeBannerRoute(pathname: string): boolean {
  if (pathname.startsWith(`${ROUTE_ORDER}/`)) {
    const itemId = pathname.slice(`${ROUTE_ORDER}/`.length);
    return Boolean(itemId) && !itemId.includes("/");
  }

  if (pathname === ROUTE_MENU) {
    return true;
  }

  if (!pathname.startsWith(`${ROUTE_MENU}/`)) {
    return false;
  }

  const categorySegment = pathname.slice(`${ROUTE_MENU}/`.length);
  if (!categorySegment || categorySegment.includes("/")) {
    return false;
  }

  return categorySegment !== "menuDetails";
}
